import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { SERVICE_SLUGS, PRIORITY_CENTRES } from "../data/site";
import { track } from "../lib/api";

const label = (s) => s.split("-").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ");

export default function Footer() {
  return (
    <footer className="noise-dark text-white mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo dark />
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            We turn your car into cash — fast, fair and hassle-free across Melbourne and regional Victoria.
          </p>
          <a href="tel:0431206206" onClick={() => track("phone_tap", { where: "footer" })} className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-gold px-5 py-3 font-bold text-brand-navy hover:bg-brand-goldDark transition-colors" data-testid="footer-call-btn">
            <Phone className="h-4 w-4" /> 0431 206 206
          </a>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-brand-gold">Services</h4>
          <ul className="mt-4 space-y-2">
            {SERVICE_SLUGS.map((s) => (
              <li key={s}><Link to={`/${s}`} className="text-sm text-white/75 hover:text-white transition-colors">{label(s)}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-brand-gold">Company</h4>
          <ul className="mt-4 space-y-2">
            {[["How It Works", "/how-it-works"], ["Areas We Service", "/areas"], ["Blog & News", "/blog"], ["FAQ", "/faq"], ["About", "/about"], ["Contact", "/contact"], ["Sell Your Car", "/sell-your-car"]].map(([l, to]) => (
              <li key={to}><Link to={to} className="text-sm text-white/75 hover:text-white transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-brand-gold">Get in touch</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-brand-gold" /><a href="mailto:info@cartocash.com.au" onClick={() => track("email_tap")} className="hover:text-white" data-testid="footer-email">info@cartocash.com.au</a></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-brand-gold" /> Melbourne &amp; regional Victoria</li>
            <li className="flex items-start gap-3"><Clock className="h-4 w-4 mt-0.5 text-brand-gold" /> Mon–Sun, 7:00am – 7:00pm</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8">
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-brand-gold">Areas we service</h4>
          <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5" data-testid="footer-areas">
            {PRIORITY_CENTRES.map(([name, slug]) => (
              <Link key={slug} to={`/areas/${slug}`} className="text-sm text-white/70 hover:text-white transition-colors">{name}</Link>
            ))}
            <Link to="/areas" className="text-sm font-bold text-brand-gold hover:text-white transition-colors" data-testid="footer-all-areas">View all areas →</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} Car To Cash. Cash for cars, Melbourne wide.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link>
            <Link to="/admin" className="hover:text-white" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
